import axios from "axios";
import moment from "moment";
import { Alert } from "rsuite";
import { getInstagramError } from "../../Errors";
import constants from "../../constants";
import fieldConstants from "../../fieldConstants";

let smsOverviewStats = [
  {
    value: 0,
    bool: true,
    title: "Targeted",
    percentage: false,
    tooltip: "Contacts to whom SMS were sent"
  },
  {
    value: 0,
    bool: true,
    title: "Total Reach",
    percentage: false,
    tooltip: "Contacts who received a SMS"
  },
  {
    value: 0,
    bool: true,
    title: "Total Engaged Users",
    percentage: false,
    tooltip: "Contacts who clicked the campaigns"
  },
  {
    value: 0,
    bool: true,
    title: "Average Engagement Rate",
    percentage: true,
    tooltip: "Average Engagement Rate"
  }
];

let emailOverviewStats = [
  {
    value: 0,
    bool: true,
    title: "Total Sent",
    percentage: false,
    tooltip: "Contacts to whom emails were sent"
  },
  {
    value: 0,
    bool: true,
    title: "Total Reach",
    percentage: false,
    tooltip: "Contacts who received an email"
  },
  {
    value: 0,
    bool: true,
    title: "Total Unique Engaged Contacts",
    percentage: false,
    tooltip: "Contacts who opened the campaign emails"
  },
  {
    value: 0,
    bool: true,
    title: "Average Engagement rate",
    percentage: true,
    tooltip: "Percentage of engaged contacts to reached"
  }
];

let socialAdsOverviewStats = [
  {
    value: 0,
    bool: true,
    title: "Total Impressions",
    percentage: false,
    tooltip: "Number of times ads were displayed"
  },
  {
    value: 0,
    bool: true,
    title: "Total Reach",
    percentage: false,
    tooltip: "FB users who received an ad"
  },
  {
    value: 0,
    bool: true,
    title: "Total Conversions",
    percentage: false,
    tooltip: "Total count of ads' objective fulfillment"
  },
  {
    value: "$0",
    bool: true,
    title: "Total cost",
    percentage: false,
    tooltip: "Total cost incurred on all campaigns"
  },
  {
    value: "$0",
    bool: true,
    title: "Cost per conversion",
    percentage: false,
    tooltip: "Effective cost per conversion"
  }
];
// Fetch Email Campaigns
export const getEmailCampaigns = async ({ filter = "all", search = "", folders_accessible = [], advanced_filters = null, page }) => {
  let responseObj = {
    row: [],
    cards: emailOverviewStats
  };
  try {
    let body = { filter_type: filter, folders_accessible, channel: "Email" }
    if(advanced_filters) { body['advanced_filters'] = advanced_filters }
    let req = {
      method: "POST",
      url: constants.socialCampaigns,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("user_token")}`
      },
      data: body,
      params: { search: search, page }
    };
    const response = await axios(req);
    if ([200, 201].includes(response.status) && response.data) {
      for (let factData of response.data) {
        responseObj.row.push({
          id: Number(factData["id"]),
          Action: {
            status: factData["campaign_status"],
            id: factData["id"]
          },
          campaign_type: factData["campaign_type"],
          name: factData["name"],
          description: factData["description"],
          sender_name: factData["sender_name"],
          sender_email: factData["sender_email"],
          subject: factData["subject"],
          emailscheduled_on: factData["campaignjob"] ?
            factData["campaignjob"]["campaign_recur"] === null ?
              factData["campaignjob"]["job_start_time"] : factData["campaignjob"]["campaign_recur"] === "daily" || "weekly" || "monthly" || "quarterly" ?
                factData["campaignjob"]["next_job_run"] : factData["campaignjob"]["campaign_recur"] === "No" ? factData["campaignjob"]["job_started_on"] :
                  ""
            : "",

          campaign_status: factData["campaign_status"] ? factData["campaign_status"] : 'draft',
          auto_aborted: factData["auto_aborted"],
          asset_created_by: factData["asset_created_by"],
          awaiting_approval_level: factData["awaiting_approval_level"],
          created_at: factData["created_at"],
          updated_at: factData["updated_at"],
          start_date: moment(factData["start_date"]).format("DD MMM, YYYY HH:mm a"),
          end_date: moment(factData["end_date"]).format("DD-MMM-YYYY"),
          scheduled_on: factData["scheduled_on"] ? moment(factData["scheduled_on"]).format("DD-MMM-YYYY") : "",
          folder: factData["folder"] || [],
          reply_to: factData["reply_to"],
          reach: factData["reach"] ? factData["reach"] : 0,
          sent: factData["sent"] ? factData["sent"] : 0,
          engagements: factData["enagement"] ? factData["enagement"] : 0,
          engaged_users: factData["enagement_user"] ? factData["enagement_user"] : 0,
          engaged_rate: factData["reach"] > 0 ? ((factData["enagement_user"] / factData["reach"]) * 100).toFixed(2) : 0,
          journey_camp: factData['journeytemplate'] ? factData['journeytemplate']['id'] : null,
          campaignjob: factData["campaignjob"],
          sendnow: factData["campaignjob"] && factData["campaignjob"]["job_started_on"] === null ? moment(factData["campaignjob"]["job_start_time"]).format("DD-MMM-YYYY HH:mm") : "",
          journey_data: factData['journeytemplate'] ? factData['journeytemplate']['jb'] : null,
          recipientdata: factData['recipient'] ? factData['recipient'] : null,
          // email_statistics: factData.hasOwnProperty("email_statistics") ? factData['email_statistics'] : {},
          email_campaign_metadata: factData['metadata_attributes'] || {},
          optimize_type: factData['optimize_type'] ? factData['optimize_type'] : null
        });
      }
      // if (response.data.email_campaign_card) {
      //   emailOverviewStats[0]["value"] = response.data.email_campaign_card.total_sent;
      //   emailOverviewStats[1]["value"] = response.data.email_campaign_card.total_reach;
      //   emailOverviewStats[2]["value"] = response.data.email_campaign_card.total_enaged_user;
      //   if (response.data.email_campaign_card.total_reach > 0) {
      //     emailOverviewStats[3]["value"] = ((response.data.email_campaign_card.total_enagement / response.data.email_campaign_card.total_reach) * 100).toFixed(2);
      //   }
      //   responseObj["cards"] = emailOverviewStats;
      // }
    }
    return responseObj;
  } catch (error) {
    Alert.error("Failed to fetch email campaigns");
    console.log(error);
    return responseObj
  }
}

// Fetch SMS Campaigns
export const getSmsCampaigns = async ({ filter = "7", search = "", advanced_filters = null, page }) => {
  let responseObj = {
    row: [],
    cards: smsOverviewStats
  };
  try {
    let body = { filter_type: filter }
    if(advanced_filters) { body['advanced_filters'] = advanced_filters }
    let req = {
      method: "POST",
      url: constants.SMS_CAMPAIGNS_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("user_token")}`
      },
      data: body,
      params: { search, page }
    };
    const response = await axios(req);

    if ([200, 201].includes(response.status) && response.data) {
      for (let record of response.data) {
        responseObj.row.push({
          id: Number(record["id"]),
          Action: {
            status: record["status"],
            id: record["id"]
          },
          name: record["name"],
          subject: record["sms_body"],
          emailscheduled_on: record["smscampaignjob"] && record["smscampaignjob"]["next_job_run"] ?
          record["smscampaignjob"]["next_job_run"] : "",
          description: record["description"] !== "null" ? record["description"] : "",
          campaign_status: record["status"],
          created_at: record["created_at"] ? record["created_at"] : "",
          updated_at: record["updated_at"] ? record["updated_at"] : "",
          start_date: record["start_date"] ? moment(record["start_date"]).format("DD-MMM-YYYY") : "",
          end_date: record["end_date"] ? moment(record["end_date"]).format("DD-MMM-YYYY") : "",
          scheduled_on: record["scheduled_on"] ? moment(record["scheduled_on"]).format("DD-MMM-YYYY") : "",
          reply_to: record["reply_to"],
          reach: record["DELIVERED"] || 0,
          sent: record["SENT"] || 0,
          engagements: record["enagement"] || 0,
          engaged_users: record['UNIQUE_CLICKED'] || 0,
          engaged_rate: record['DELIVERED'] && record['UNIQUE_CLICKED'] ? (record['UNIQUE_CLICKED'] / record['DELIVERED']) : 0,
          campaignjob: record["smscampaignjob"],
          recipientdata: record['recipient'] ? record['recipient'] : null,
          // sms_statistics: record.hasOwnProperty("sms_statistics") ? record['sms_statistics'] : {},
          optimize_type: record['optimize_type'] ? record['optimize_type'] : null
        });
      }
    }
    return responseObj;
  } catch (error) {
    Alert.error("Failed to fetch SMS campaigns");
    console.log(error);
    return responseObj;
  }
}

// Fetch Social posts
export const getSocialCampaigns = async ({ filter = "7", search = "", advanced_filters = null }) => {
  try {
    let row = [];
    let body = { filter }
    if(advanced_filters) {body['advanced_filters'] = advanced_filters}
    let req = {
      method: "POST",
      url: constants.SOCIAL_CAMPAIGNS_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("user_token")}`
      },
      data: body,
      params: { search }
    };
    const response = await axios(req);

    if (response.data.status === "success" && response.data.factorealcampaigns.length) {
      for (let factData of response.data.factorealcampaigns) {
        let fbPageList = [], twitterPageList = [], linkedinPageList = [], instagramPageList = [];
        if (factData["campaignaccounts"] && factData["campaignaccounts"].length) {
          for (let page of factData["campaignaccounts"]) {
            if (page.user_id != null) {
              twitterPageList.push(page.user_id);
            } else if (page.page_id != null) {
              fbPageList.push(page.page_id);
            } else if (page.app_id != null) {
              linkedinPageList.push(page.app_id) 
            } else if(page.instagram_bussiness_acc_id != null){
              instagramPageList.push(page.instagram_bussiness_acc_id)
            }
          }
        }

        const row_data = {
          id: Number(factData["id"]),
          name: factData["name"] || "",
          description: factData["description"] || "",
          status: factData["campaign_status"],
          reach_percentage: "",
          created_at: factData["created_at"],
          updated_at: factData["updated_at"],
          schedule: factData["start_date"] ? moment(factData["start_date"]).format("DD MMM, YYYY") : "",
          isFacebook: fbPageList.length > 0 ? true : false,
          isTweet: twitterPageList.length > 0 ? true: false,
          isLinkedin: linkedinPageList.length > 0 ? true: false,
          isInstagram: instagramPageList.length > 0 ? true: false,
          fbPageList: fbPageList,
          twitterPageList: twitterPageList,
          linkedinPageList: linkedinPageList,
          instagramPageList: instagramPageList,          
          linkedin_activity: factData["linkedinposts"] && factData["linkedinposts"].length ? factData["linkedinposts"][0] : [],
          postType: (factData["factorealcampaigndatum"] && factData["factorealcampaigndatum"]["json_data"] && factData["factorealcampaigndatum"]["json_data"]["type"]) ? factData["factorealcampaigndatum"]["json_data"]["type"] : "All"
        };
        row_data["reactions"] = 0;
        row_data["clicks"] = 0;
        row_data["comments"] = 0;
        row_data["reachCount"] = 0;
        row_data["engageCount"] = 0;
        row_data["uniqueFanReachCount"] = 0;

        row_data["retweet"] = 0;
        row_data["reply"] = 0;
        row_data["like"] = 0;
        row_data["quote"] = 0;
        row_data["reach"] = 0;
        row_data["tweetclick"] = 0;

        row_data["l_impression"] = 0;
        row_data["l_reactions"] = 0;
        row_data["l_clicks"] = 0;
        row_data["l_comments"] = 0;
        row_data["l_share"] = 0;

        row_data["i_engagements"] = 0;
        row_data["i_saves"] = 0;
        row_data["i_comments"] = 0;
        row_data["i_likes"] = 0;
        row_data["i_reach"] = 0;

        if (factData["fbposts"] && factData["fbposts"].length) {
          for (let singlePost of factData["fbposts"]) {
            row_data["fbPostId"] = singlePost.post_id;
            if (singlePost.post_report) {
              if (singlePost.post_report.reactCount) {
                row_data["reactions"] = row_data["reactions"] + singlePost.post_report.reactCount;
              }
              if (singlePost.post_report.clickCount) {
                row_data["clicks"] = row_data["clicks"] + singlePost.post_report.clickCount;
              }
              if (singlePost.post_report.commentCount) {
                row_data["comments"] = row_data["comments"] + singlePost.post_report.commentCount;
              }
              if (singlePost.post_report.reachCount) {
                row_data["reachCount"] = row_data["reachCount"] + singlePost.post_report.reachCount;
              }
              if (singlePost.post_report.engageCount) {
                row_data["engageCount"] = row_data["engageCount"] + singlePost.post_report.engageCount;
              }
              if (singlePost.post_report.uniqueFanReachCount) {
                row_data["uniqueFanReachCount"] = row_data["uniqueFanReachCount"] + singlePost.post_report.uniqueFanReachCount;
              }
            }
          }
        }
        if (factData["tweets"] && factData["tweets"].length) {
          for (let singlePost of factData["tweets"]) {
            row_data["tweetPostId"] = singlePost.tweet_id;
            row_data["tweetUserId"] = singlePost.user_id;
            if (singlePost.tweet_report) {
              if (singlePost.tweet_report.retweet_count) {
                row_data["retweet"] = row_data["retweet"] + singlePost.tweet_report.retweet_count;
              }
              if (singlePost.tweet_report.quote_count) {
                row_data["retweet"] = row_data["retweet"] + singlePost.tweet_report.quote_count;
              }
              if (singlePost.tweet_report.reply_count) {
                row_data["reply"] = row_data["reply"] + singlePost.tweet_report.reply_count;
              }
              if (singlePost.tweet_report.like_count) {
                row_data["like"] = row_data["like"] + singlePost.tweet_report.like_count;
              }
              if (singlePost.tweet_report.quote_count) {
                row_data["quote"] = row_data["quote"] + singlePost.tweet_report.quote_count;
              }
              if (singlePost.tweet_report.impression_count) {
                row_data["reach"] = row_data["reach"] + singlePost.tweet_report.impression_count;
              }
              if (singlePost.tweet_report.url_link_clicks) {
                row_data["tweetclick"] = row_data["tweetclick"] + singlePost.tweet_report.url_link_clicks;
              }
            }
          }
        }
        if (factData["linkedinposts"] && factData["linkedinposts"].length) {
          for (let singlePost of factData["linkedinposts"]) {
            row_data["linkedinPostId"] = singlePost.post_id;
            if (singlePost?.post_report) {
              let data = singlePost.post_report;

              if (data.impressionCount) {
                row_data["l_impression"] = row_data["l_impression"] + data.impressionCount;
              }
              if (data.likeCount) {
                row_data["l_reactions"] = row_data["l_reactions"] + data.likeCount;
              }
              if (data.clickCount) {
                row_data["l_clicks"] = row_data["l_clicks"] + data.clickCount;
              }
              if (data.commentCount) {
                row_data["l_comments"] = row_data["l_comments"] + data.commentCount;
              }
              if (data.shareCount) {
                row_data["l_share"] = row_data["l_share"] + data.shareCount;
              }
            }
          }  
        }
        
        if (factData && factData["instagramposts"]) {
          for(let singlePost of factData["instagramposts"]) {
            row_data["instagram_post_id"] = singlePost.post_id;
            row_data["shortcode"] = factData["instagramposts"][0].shortcode;
            
            if (singlePost?.post_report) {
                let data = singlePost.post_report;
                if(data.engagement){
                  row_data["i_engagements"] = row_data["i_engagements"] + data.engagement;
                }
                if(data.saved){
                  row_data["i_saves"] = row_data["i_saves"] + data.saved;
                }
                if (data.comments_count){
                  row_data["i_comments"] = row_data["i_comments"] + data.comments_count;
                }
                if (data.like_count){
                  row_data["i_likes"] = row_data["i_likes"] + data.like_count;
                }
                if (data.reach){
                  row_data["i_reach"] = row_data["i_reach"] + data.reach;
              }
            }
          }
        }
      
        if (factData && factData["factorealcampaigndatum"] && factData["factorealcampaigndatum"]["json_data"]) {
          const instagramErrors = factData["factorealcampaigndatum"]["json_data"]["instagram_publish_errors"]
          const facebookErrors = factData["factorealcampaigndatum"]["json_data"]["facebook_publish_errors"]
          const twitterErrors = factData["factorealcampaigndatum"]["json_data"]["tweet_publish_errors"]
          const linkedinErrors = factData["factorealcampaigndatum"]["json_data"]["linkedin_publish_errors"]

          row_data["post_type"] = factData["factorealcampaigndatum"] ? `${factData["factorealcampaigndatum"]["json_data"]["type"]} post` : "post"
          row_data["post_id"] = factData["factorealcampaigndatum"]["json_data"]["post_id"] ? factData["factorealcampaigndatum"]["json_data"]["post_id"] : "",
          row_data["instagram_errors"] =  instagramErrors
          row_data["facebook_errors"] =  facebookErrors
          row_data["twitter_errors"] =  twitterErrors
          row_data["linkedin_errors"] =  linkedinErrors

          if(instagramPageList.length && instagramErrors && instagramErrors.length){
            let error_message = ""
            for(const item of instagramPageList){
              const value = instagramErrors.find((error) => item === error.instagram_business_acc_id)
              if(value){
                error_message = value.instagram_username + ": "
                error_message = error_message + getInstagramError(value) + "<br/>"
              }
            }
            row_data["instagram_error"] = error_message
          }
          if(fbPageList.length && facebookErrors && facebookErrors.length){
            let error_message = ""
            for(const item of fbPageList){
              const value = facebookErrors.find((error) => item === error.facebook_page_id)
              if(value){
                error_message = error_message + value.error.message + "<br/>"
              }
            }
            row_data["facebook_error"] = error_message
          }
          if(twitterPageList.length && twitterErrors && twitterErrors.length){
            let error_message = ""
            for(const item of twitterPageList){
              const value = twitterErrors.find((error) => item === error.twitter_user_id)
              if(value){
                error_message = error_message + value.error.message + "<br/>"
              }
            }
            row_data["twitter_error"] = error_message
          }
          if(linkedinPageList.length && linkedinErrors && linkedinErrors.length){
            let error_message = ""
            for(const item of linkedinPageList){
              const value = linkedinErrors.find((error) => item === error.linkedin_org_urn)
              if(value){
                error_message = error_message + value.error.message + "<br/>"
              }
            }
            row_data["linkedin_error"] = error_message
          }
        }
        row.push(row_data);
      }
    }
    return row;
  } catch (error) {
    Alert.error("Failed to fetch social campaigns");
    console.log(error);
  }
};

// Fetch Social-ads
export const getSocialAds = async ({ filter = "7", search = "", advanced_filters = null }) => {
  let responseObj = {
    row: [],
    cards: socialAdsOverviewStats
  };
  try {
    let row = [];
    let body = { filter }
    if(advanced_filters) {body['advanced_filters'] = advanced_filters}
    let req = {
      method: "POST",
      url: constants.SOCIAL_ADS_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("user_token")}`
      },
      data: body,
      params: { search }
    };
    const response = await axios(req);

    if (response.data.status === "success" && response.data.factorealcampaigns.length) {
      for (let factData of response.data.factorealcampaigns) {
        if (factData && factData["name"]) {
          let metadata = factData["fbadsauidence"] ? factData["fbadsauidence"]['last_30d_report'] ? factData["fbadsauidence"]['last_30d_report'] : null : null
          let obj = {
            id: Number(factData["id"]),
            campaign_type: factData["campaign_type"],
            name: factData["name"],
            status: factData["campaign_status"],
            journey_ad: factData["campaign_type"] === fieldConstants.journey_ad ? true : false,
            created_at: factData["created_at"],
            updated_at: factData["updated_at"],
            start_date: moment(factData["created_at"]).format("DD MMM, YYYY HH:mm a"),
            total_cost: metadata ? (metadata.spend ? parseFloat(metadata.spend).toFixed(2) : 0) : 0,
            cost_per_conversion: metadata ? (metadata.avg_cost_per_conversion ? parseFloat(metadata.avg_cost_per_conversion).toFixed(2) : 0) : 0,
            total_reach: metadata ? (metadata.total_reach ? metadata.total_reach : 0) : 0,
            total_impressions: metadata ? (metadata.impressions ? metadata.impressions : 0) : 0,
            total_conversions: metadata ? (metadata.conversions ? metadata.conversions : 0) : 0,
            fbadsauidence: factData["fbadsauidence"] ? factData["fbadsauidence"] : 0,
            social_ad_filter: factData["fbadsauidence"] ? factData["fbadsauidence"] : 0,
            recipientdata: factData['recipient'] ? factData['recipient'] : null,
            budjetdesigndata: factData['factorealcampaigndatum'] ? factData['factorealcampaigndatum'] : null,
          };
          row.push(obj);
        }
      }
    }
    if (response.data.query_fb_auidience) {
      let stats = response.data.query_fb_auidience;
      stats.total_reach && stats.total_reach != "" ? socialAdsOverviewStats[1]["value"] = stats.total_reach : socialAdsOverviewStats[1]["value"] = 0;
      stats.conversions && stats.conversions != "" ? socialAdsOverviewStats[2]["value"] = stats.conversions : socialAdsOverviewStats[2]["value"] = 0;
      stats.spend && stats.spend != "" ? socialAdsOverviewStats[3]["value"] = `$${stats.spend}` : socialAdsOverviewStats[3]["value"] = `$${0}`;
      stats.avg_cost_per_conversion && stats.avg_cost_per_conversion != "" ? socialAdsOverviewStats[4]["value"] = `$${parseInt(stats.avg_cost_per_conversion).toFixed(2)}` : socialAdsOverviewStats[4]["value"] = 0;
    }
    responseObj["row"] = row;
    responseObj["cards"] = socialAdsOverviewStats;
    return responseObj;
  } catch (error) {
    Alert.error("Failed to fetch social-ads campaigns");
    console.log(error);
    return responseObj;
  }
}

export const getAllSocialPages = async () => {
  try {
    const response = await axios({
      method: "post",
      url: constants.getAllSocialPages,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("user_token")}`
      }
    });
    if (response.status == 200) {
      if (response.data.success && response.data.data) {
        return response.data.data
      } else {
        return {}
      }
    } else {
      Alert.error("Unable to fetch social pages list");
      return {}
    }
  } catch (error) {
    Alert.error("something went wrong");
    return error;
  }
};

export const deleteCampaign = async data => {
  try {
    let deleteRequest = {
      method: "delete",
      url: `${constants.factorealcampaigns}/${data.id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("user_token")}`
      }
    };
    const response = await axios(deleteRequest);
    if ([200, 201].includes(response.status)) {
      Alert.success(`Campaign deleted successfully`, constants.alertDuration);
      return true;
    }
  } catch (error) {
    console.log("error in deleting camapign", error);
    return false
  }
};

export const deleteSmsCampaign = async data => {
  const req = {
    method: "DELETE",
    url: `${constants.deleteSmsCampaign}/${data.id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${window.localStorage.getItem("user_token")}`
    }
  };
  return axios(req)
    .then(resp => {
      Alert.success(`Campaign deleted successfully`, constants.alertDuration);
      return true
    })
    .catch(error => {
      Alert.error(error.message, constants.alertDuration);
      return false
    })
};
